import { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { postData } from '../../../../ApiServices/ApiService';
import { ORG_UPDATE_DEVICE_ID } from '../../../../ApiServices/BaseURL';
import { useTheme } from '../../../../GlobalContext/GlobalContext';
import { logFrontendException } from '../../../../Utils/Exception';

const UserDeviceIdController = (userInfo, onRefresh) => {
    const { setIsLoginPopup } = useTheme();
    const [deviceData, setDeviceData] = useState({
        device_name: userInfo?.device_name || '',
        device_type: userInfo?.device_type ? { lable: userInfo?.device_type || '', value: userInfo?.device_type || '' } : null,
        device_id: userInfo?.device_id || ''
    });
    const [deviceTypes, setDeviceTypes] = useState(['Persona', 'Company', 'Mobile']);
    const [deviceUpdateSuccess, setDeviceUpdateSuccess] = useState('');
    const [deviceUpdateError, setDeviceUpdateError] = useState('');
    const [deviceIdError, setDeviceIdError] = useState('');
    const [updateLoading, setUpdateLoading] = useState(false);
    const [generatedDeviceId, setGeneratedDeviceId] = useState('');
    const [copied, setCopied] = useState(false);
    const [deviceTypeError, setDeviceTypeError] = useState('');
    const pageName = "UserDeviceIdController";
    const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;

    useEffect(() => {
        if (userInfo) {
            console.log('----userInfo----', userInfo)
            setDeviceData({
                device_name: userInfo?.device_name || '',
                device_type: userInfo?.device_type ? { label: userInfo?.device_type, value: userInfo?.device_type } : null,
                device_id: userInfo?.device_id || ''
            })
        }

    }, [userInfo])

    const handleDeviceChange = (field, value) => {
        setDeviceData({
            ...deviceData,
            [field]: value
        });
    };

    const handleInputChange = (field, value) => {
        setDeviceData({
            ...deviceData,
            [field]: value
        });
    };



    const handleUpdateDevice = async () => {
        setDeviceUpdateSuccess('');
        setDeviceUpdateError('');
        setDeviceIdError('');
        setGeneratedDeviceId('');
        setDeviceTypeError('')
        if (!deviceData?.device_type?.value) {
            setDeviceTypeError('Device Type is required.');
            return
        }
        if (!deviceData.device_id) {
            setDeviceIdError('Device ID is required.');
            return
        }
        try {
            setUpdateLoading(true);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = {
                "emp_id_auth": storedUserInfo?.emp_id,
                'emp_id': userInfo?.emp_id || 0,
                'device_id': deviceData?.device_id || '',
                'device_type': deviceData?.device_type?.value || '',
                'device_name': deviceData?.device_name || '',
                'action': 'device_update'
            }

            // Make the API call
            const response = await postData(ORG_UPDATE_DEVICE_ID, payLoad);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.status_code === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        setDeviceUpdateSuccess(responseData?.info || 'Device ID updated successfully');
                        onRefresh();
                        setTimeout(() => {
                            setDeviceUpdateSuccess('');
                        }, 3000);
                    } else {
                        setDeviceUpdateError(responseData?.info || 'Failed to update device ID.');
                        logFrontendException(storedUserId, pageName, "handleUpdateDevice", responseData?.info || '');
                    }
                } else {
                    setDeviceUpdateError(responseData?.info || 'Failed to update device ID.Please try again.');
                    logFrontendException(storedUserId, pageName, "handleUpdateDevice-else", responseData || '');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setDeviceUpdateError('Unauthorized access. Your session may have expired. Please log in again.');
                setIsLoginPopup(true);
                logFrontendException(storedUserId, pageName, "handleUpdateDevice-token", response || '');
            }
            else {
                setDeviceUpdateError('Failed to update device ID and try again later.');
                logFrontendException(storedUserId, pageName, "handleUpdateDevice", response || '');
            }
        } catch (error) {
            setDeviceUpdateError('Failed to update device ID.Please check your internet connection and try again.');
            logFrontendException(storedUserId, pageName, "handleUpdateDevice-catch", error || '');
        } finally {
            setUpdateLoading(false);
        }
    };

    const handleCancel = () => {
        // Reset fields or handle cancellation
        setDeviceData({
            device_name: '',
            device_type: '',
            device_id: ''
        });
        setDeviceUpdateError('');
        setDeviceUpdateSuccess('');
        setDeviceIdError('');
        setGeneratedDeviceId('');
        setDeviceTypeError('')
    };

    const handleGenerateDeviceId = () => {
        const newId = uuidv4();
        setGeneratedDeviceId(newId);
        localStorage.setItem('device_id', newId);
    };

    const handleCopyToClipboard = () => {
        if (generatedDeviceId) {
            navigator.clipboard.writeText(generatedDeviceId).then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000); // Clear after 2 seconds
            });
        }
    };

    return {
        handleUpdateDevice,
        handleCancel,
        deviceTypes,
        deviceData,
        handleDeviceChange,
        handleInputChange,
        updateLoading, setDeviceIdError,
        deviceUpdateSuccess, setDeviceTypeError,
        deviceUpdateError, deviceIdError, copied, deviceTypeError,
        handleGenerateDeviceId, generatedDeviceId, handleCopyToClipboard
    };
};

export default UserDeviceIdController;
